import ChangeObserver from './ChangeObserverImpl'
import Log from '../../Log'

export default class ResizeObserver extends ChangeObserver {
  constructor (node, cb) {
    super(node)
    this._cb = cb
    window.addEventListener('resize', this._cb)
  }

  stop () {
    window.removeEventListener('resize', this._cb)
    Log.debug('Removed ScrollListener')
  }
}
